import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { prepareRequest, useApplicationState, useSettings } from '@atlas/core';

import { useIframePostMessage } from 'hooks/useIframePostMessage';

import { createEventHandlers } from './eventHandlers';

const languageMapper = {
  ENG: 'en',
  IND: 'in',
  JPN: 'ja',
  KOR: 'ko',
  POR: 'pt',
  SPA: 'es',
  THA: 'th',
  TUR: 'tr',
  VIE: 'vi',
  ZHO: 'zh',
};

const FirstSportsbook = ({ iframeLink = 'https://prod20508.442hattrick.com' }) => {
  const [authToken, setAuthToken] = useState('logout');
  const { lang } = useSettings();
  const { authenticated, resolved } = useApplicationState();
  const realLang = languageMapper[lang] || languageMapper.ENG;
  const origin = encodeURIComponent(window.location.origin);
  const scriptLocation = new URL('whl.js', window.location.origin);
  const offsetHours = new Date().getTimezoneOffset() / 60;
  const iframeRef = useRef(null);

  const eventHandlers = createEventHandlers({ iframeRef });

  const logoutToken = useCallback(() => setAuthToken('logout'), []);

  const getAuthToken = useCallback(async () => {
    const request = prepareRequest({
      method: 'POST',
      url: 'betting/client/token:create',
    });

    try {
      const response = await request();
      setAuthToken(response.token);
    } catch (_) {
      /* empty */
    }
  }, []);

  useIframePostMessage(eventHandlers, iframeRef, iframeLink);

  useEffect(() => {
    if (!resolved) {
      return;
    }

    if (authenticated) {
      getAuthToken();
    } else {
      logoutToken();
    }
  }, [resolved, authenticated, getAuthToken, logoutToken]);

  return (
    <div className="viewport-height page__main">
      <iframe
        frameBorder="0"
        ref={iframeRef}
        src={`${iframeLink}/${realLang}/sports?oddsStyleId=1&tz=${offsetHours}&parent=${origin}&api=${scriptLocation}&operatorToken=${authToken}`}
        title="sportsbook"
        width="100%"
      />
    </div>
  );
};

FirstSportsbook.propTypes = {
  iframeLink: PropTypes.string,
};

export default FirstSportsbook;
